/* eslint-disable vars-on-top */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-sequences */
/* eslint-disable key-spacing */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable no-alert */
/* eslint-disable no-multi-str */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable no-tabs */
/* eslint-disable no-param-reassign */
/* eslint-disable indent */
/* eslint-disable object-curly-newline */
/* eslint-disable no-multi-spaces */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint no-console: ["error", { allow: ["log", "group", "groupEnd", "warn", "error"] }] */

'use strict';

import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Overlay from 'ol/Overlay';
import OSM from 'ol/source/OSM';
import Point from 'ol/geom/Point';
import TileJSON from 'ol/source/TileJSON';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import {Icon, Style, Text} from 'ol/style';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {fromLonLat} from 'ol/proj';
import {getVectorContext} from 'ol/render';

console.log('index.js loaded!');

window.addMarker = function(element, img_src, var_arr_points){
  let var_tel     = element.tel.length > 0 ? '<br><strong>Telephone</strong>: ' + element.tel : '';
  let var_web     = element.webaddress.length > 0 ? `<br><strong>Website</strong>: <a href="${element.webaddress}">click here</a>` : '';
  let var_email   = element.email.length > 0 ? '<br><strong>Email</strong>: ' + element.email : '';

  let var_street    = element.street.length > 0 ?           element.street : '';
  let var_postcode  = element.postcode.length > 0 ? ', ' +  element.postcode : '';
  let var_city      = element.city.length > 0 ?     ', ' +  element.city : '';
  let var_country   = element.country.length > 0 ?  ', ' +  element.country : '';

  let var_address = '<br><strong>Address</strong>: ' + var_street + var_postcode + var_city + var_country;
  let var_card = `<h3>${element.name}</h3>${var_tel}${var_web}${var_email}${var_address}`;

  // Set point.
    //console.log(element.lat);
    let var_feature = new Feature({
      geometry: new Point(fromLonLat([element.lng, element.lat])),
      name: var_card
    });

  // Set styles of cities.
    var_feature.setStyle(
      new Style({
        image: new Icon({
          crossOrigin: 'anonymous',
          // For Internet Explorer 11
          imgSize: [29, 24],
          src: img_src
        })
      })
    );

  // Store new point to array.
    var_arr_points.push(var_feature);
}

window.loadMap = function(var_arr_points){
  // Add Tile, layer and vector.
    /*
    var var_rasterLayer = new TileLayer({
      source: new TileJSON({
        url: 'https://a.tiles.mapbox.com/v3/aj.1x1-degrees.json?secure=1',
        crossOrigin: ''
      }),
    });
    */
    var var_rasterLayer = new TileLayer({
      source: new OSM() // The standard world-map.
    })

    var var_vectorSource = new VectorSource({
      features: var_arr_points
    });

    var var_vectorLayer = new VectorLayer({
      source: var_vectorSource
    });

  // Load the map.
    var var_map = new Map({
      target: document.getElementById('map'),  // To attach the map object to the <div>, the map object takes a target into arguments. The value is the id of the <div>.
      /*
      The layers: [ ... ] array is used to define the list of layers available in the map.
      The first and only layer right now is a tiled layer.

      Layers in OpenLayers are defined with a type (Image, Tile or Vector) which contains a source.
      The source is the protocol used to get the map tiles.
      */
      layers: [var_rasterLayer, var_vectorLayer],
      /*
      The next part of the Map object is the View.
      The view allows to specify the center, resolution, and rotation of the map.
      The simplest way to define a view is to define a center point and a zoom level.
      Note that zoom level 0 is zoomed out.
      */
      view: new View({
        center: fromLonLat([17.41, 38.82]), // lon/lat coordinates ordered the opposite than Google Maps.
        zoom: 0
      })
    });

  // Create and define popup.
    var element = document.getElementById('popup');

    var popup = new Overlay({
      element: element,
      positioning: 'bottom-center',
      stopEvent: false,
      offset: [0, -10],
    });
    var_map.addOverlay(popup);

  // display popup on click
    var_map.on('click', function (evt) {
      var feature = var_map.forEachFeatureAtPixel(evt.pixel, function (feature) {
        return feature;
      });
      if (feature) {
        $(element).popover('dispose');
        var coordinates = feature.getGeometry().getCoordinates();
        popup.setPosition(coordinates);
        $(element).popover({
          placement: 'top',
          html: true,
          content: feature.get('name'),
        });
        $(element).popover('show');
      } else {
        $(element).popover('dispose');
      }
    });

  // change mouse cursor when over marker
    var_map.on('pointermove', function (e) {
      if (e.dragging) {
        $(element).popover('dispose');
        return;
      }
      var pixel = var_map.getEventPixel(e.originalEvent); // Position of mouse.
      var hit = var_map.hasFeatureAtPixel(pixel); // Are we on a marker? Did we hit it with the mouse by overlay?
      var_map.getTarget().style.cursor = hit ? 'pointer' : '';
    });
}